import axios from "axios";
// import { setAlert } from './alert';
import {
  BLOCK_USER,
  BLOCK_USER_ERROR,
  GET_BLOCKED_USERS,
  GET_BLOCKED_USERS_ERROR,
  UNBLOCK_USER,
  UNBLOCK_USER_ERROR,
  CLEAR_BLOCKED_USERS,
} from "./types";

// Block a user
export const blockUser = (channelid) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const formData = new FormData();
  formData.append("channelid", JSON.stringify(channelid));

  try {
    const res = await axios.post(
      `/api/blockuser/block`,
      formData,
      channelid,
      config
    );

    dispatch({
      type: BLOCK_USER,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: BLOCK_USER_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Unblock a user
export const unblockUser = (channelid) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const formData = new FormData();
  formData.append("channelid", JSON.stringify(channelid));

  try {
    const res = await axios.post(
      `/api/blockuser/unblock`,
      formData,
      channelid,
      config
    );

    dispatch({
      type: UNBLOCK_USER,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: UNBLOCK_USER_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get blocked users for logged in user
export const getBlockedUsers = (channelid) => async (dispatch) => {
  dispatch({ type: CLEAR_BLOCKED_USERS });
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const formData = new FormData();
  formData.append("channelid", JSON.stringify(channelid));

  try {
    const res = await axios.post(
      `/api/blockuser/blocked_users`,
      formData,
      channelid,
      config
    );

    dispatch({
      type: GET_BLOCKED_USERS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: GET_BLOCKED_USERS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
